import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import CryptoJS from "crypto-js";

export const downloadCSV = async (filter, apiUrl = `/api/report/download`) => {
  let url = apiUrl;
  let response = await axios({
    url: url,
    method: 'post',
    data: {
      ...filter,
      from: filter?.from ? moment(filter?.from).format('DD/MM/YYYY') : null,
      to: filter?.to ? moment(filter?.to).format('DD/MM/YYYY') : null,
    },
    responseType: 'blob',
  });

  let fileName = 'file.txt';
  try {
    fileName = response.headers['content-disposition'].split('=')[1].replace(/"/g, '');
  } catch (error) {
    console.log(error);
  }

  url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName); //or any other extension
  document.body.appendChild(link);
  link.click();
};

export function s2ab(s) {
  let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  let view = new Uint8Array(buf); //create uint8array as viewer
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
}

export const downloadXLSX = async (filter, apiUrl = `/api/report/download`) => {
  function fitToColumn(arrayOfArray) {
    return arrayOfArray[0].map((a, i) => {
      if (i === 1) return { wch: 15 };
      if (i === 6) return { wch: 30 };
      if (i === 8) return { wch: 30 };
      if (i === 11) return { wch: 15 };
      if (i === 17) return { wch: 30 };
      if (i === 35) return { wch: 50 };
      return { wch: a?.toString()?.length };
    });
  }

  function s2ab(s) {
    let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    let view = new Uint8Array(buf); //create uint8array as viewer
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
    return buf;
  }

  const decryptAES  = (cipherText) => {
    if(cipherText === null) return '';
    cipherText = cipherText.replace('[encrypt]','');
    console.log('cipherText:'+cipherText);
    const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse('A9F66A37C4C10BBD83F7BA270962731E'), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return CryptoJS.enc.Utf8.stringify(decrypted);
  }

  try {
    let response = await axios({
      url: apiUrl,
      method: 'post',
      data: {
        ...filter,
        from: filter?.from ? moment(filter?.from).format('DD/MM/YYYY') : null,
        to: filter?.to ? moment(filter?.to).format('DD/MM/YYYY') : null,
      },
    });
  console.log('3:44');
    let ws_data = response.data?.split('\n').map((row) =>
      row
        ?.split('|')
          .map((e) => e?.replace('"', ''))
          .map((e) => e?.replace('"', ''))
          .map((e) => e? e.startsWith('[encrypt]',0)?decryptAES(e):e:e)
    );
    let wb = XLSX.utils.book_new();
    wb.Props = {
      Title: 'Báo cáo',
      Subject: 'Báo cáo',
      Author: 'FWD',
      CreatedDate: new Date(),
    };
    let worksheet = XLSX.utils.aoa_to_sheet(ws_data);
    worksheet['!cols'] = fitToColumn(ws_data);

    wb.SheetNames.push('Data');
    wb.Sheets['Data'] = worksheet;
    let wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    let fileName = 'Report_' + moment().format('YYYYMMDD_hhmmss') + '.xlsx';
    saveAs(new Blob([s2ab(wbOut)], { type: 'application/octet-stream' }), fileName);
  } catch (error) {
    console.log('Xay ra loi!');
    console.log(error);
    return downloadCSV(filter, apiUrl);
  }
};

const Button = ({ filter }) => {
  const onClick = async () => downloadXLSX(filter);
  return (
    <button className='btn btn-outline-primary' onClick={onClick} type='button'>
      Download
    </button>
  );
};

const mapStateToProps = (state) => {
  const filter = state?.report?.condition;
  return { filter };
};

export default connect(mapStateToProps)(Button);
